import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchDiscountCouponList = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/discountCoupon/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.try_again) {
            dispatch('fetchDiscountCouponList', payload)
        } else {
            commit('setDiscountCouponList', res.data.response)         
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchDiscountCouponData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/discountCoupon/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});                
            }
            
            commit('setDiscountCouponData', {response: res.data.response, copy: payload.copy})   
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetDiscountCouponData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitDiscountCouponData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/discountCoupon/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            router.push(router.currentRoute.fullPath.replace('/form/', ''))
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteDiscountCouponData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/discountCoupon/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchDiscountCouponList')
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/discountCoupon/actions.js